import React, { useState } from 'react'
import { useEffect } from 'react'
import { getBlockedMediums, createTopic, deleteTopic, updateTopic } from '../../../services/admin.js'
import Pagination from '../../../components/tablePagination/index.js';
import Checkbox from '../Subcomponents/checkbox.js';
import { useNavigate, useSearchParams } from "react-router-dom";
import moment from 'moment';
import { filterList } from './list.js';
import Search from '../../../components/search';
import "./index.css"
import { toast } from "react-toastify";

export default function BlockedMedium() {
  const [list, setList] = useState([]);
  const [totalcount, setTotalCount] = useState(0);
  const [timezonePage, settimezonePage] = useState(1);
  const [timezonerowsPerPage, settimezonerowsPerPage] = useState(10);

  const [searchValue, setSearchValues] = useState();
  const [filterValues, setFilterValues] = useState("name");

  // 🔑 store filters here
  const [filters, setFilters] = useState({
    name: "",
    email: "",
    blocked_by: "",
    created_at: ""
  });

  const navigate = useNavigate();

  useEffect(() => {
    let info = {
      page: timezonePage,
      rowsPerPage: timezonerowsPerPage,
      ...filters, // ⬅️ include filters
    };
    getBlocked(info);
  }, [timezonePage, timezonerowsPerPage, filters]); // ⬅️ re-run when filters/pagination changes

  const getBlocked = (info) => {
    getBlockedMediums(info)
      .then((data) => {
        if (data.data.status) {
          setList(data.data.data.data);
          setTotalCount(data.data.data.total);
        }
      })
      .catch(() => {});
  };

  // 🔑 handle pagination
  const getPaginationData = (data) => {
    settimezonePage(data.page);
    settimezonerowsPerPage(data.rowsPerPage);
  };

  // 🔑 handle filter search
  const filterBlockedMediums = (constants) => {
    const { name = "", email = "", blocked_by = "", created_at = "" } = constants;
    setFilters({ name, email, blocked_by, created_at }); // update filters
    settimezonePage(1); // reset to page 1 on new search
  };

  const navigateEdit = (e, id) => {
    if (e.target.className === "capitalizeMedium") {
      navigate(`/profile-edit/${id.blocked_user_id}`);
    }
  };

  return (
    <>
      <div className="d-flex justify-content-end gap-10 flex-wrap">
        <Search
          callApi={filterBlockedMediums}
          list={filterList}
          setSearchValues={setSearchValues}
          setFilterValues={setFilterValues}
          searchValue={searchValue}
          filterValues={filterValues}
          isDatepickerShow={1}
          oneDayAdded={1}
        />
      </div>

      <div className="d-flex">
        <a
          className="export-btn"
          href={`${process.env.REACT_APP_API_URL_EXPORT}export-blocked-mediums`}
        >
          Export Table
        </a>
      </div>

      <div className="table-box-medium table-box-medium-blocked">
        <table className="caseTable">
          <tbody>
            <tr className="dark">
              <th><span className="scren-name">Medium Name</span></th>
              <th>Medium Email</th>
              <th>Blocked By</th>
              <th>Date</th>
            </tr>
            {list.length > 0 ? (
              list.map((item) => (
                <tr
                  key={item.id}
                  onClick={(e) => navigateEdit(e, item)}
                  className="innr pointer"
                >
                  <td className="capitalizeMedium">
                    {item.blocked_user
                      ? `${item.blocked_user.first_name} ${item.blocked_user.last_name}`
                      : "-"}
                  </td>
                  <td>{item.blocked_user ? item.blocked_user.email : "-"}</td>
                  <td>{item.blocked_by ? `${item.blocked_by.screen_name}` : "-"}</td>
                  <td>{new Date(item.created_at).toLocaleDateString()}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={6} className="text-center">No Records Found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <Pagination
        rowsPerPageOptions={[5, 10, 25]}
        count={totalcount}
        activeTab={"admindetectedTimezones"}
        timezonePage={timezonePage}
        timezonerowsPerPage={timezonerowsPerPage}
        getPaginationData={getPaginationData}
      />
    </>
  );
}
